class StickyAtcContainer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const target = document.querySelector('product-info .product-form__submit');
        if (!target) return;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting && window.scrollY > target.offsetTop) {
                    this.classList.remove('hidden')
                } else {
                    this.classList.add('hidden')
                }
            });
        });
        observer.observe(target);


        document.addEventListener('DOMContentLoaded', () => {
            this.querySelector('.close-icon').addEventListener('click', () => {
                document.querySelector('sticky-atc-container').remove();
            })
            this.querySelector('.product-variant-id').addEventListener('change', (event) => {
                let selectedPrice = event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-price');
                this.querySelector('.atc-product-price-element .amount').textContent = selectedPrice;
                if (event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-compare-at-price')) {
                    this.querySelector('.atc-product-price-strikethrough').textContent = event.target.querySelector('option[value="'+event.target.value+'"]').getAttribute('data-compare-at-price');
                } else {
                    this.querySelector('.atc-product-price-strikethrough').textContent = '';
                }
                if(this.querySelector('[data-discount-controller-variant]')) {
                    this.querySelector('[data-discount-controller-variant]').setAttribute('data-discount-controller-variant', event.target.value);
                }
            });
            this.querySelector('.product-variant-id').dispatchEvent(new CustomEvent('change'));
        })
    }

}
customElements.define('sticky-atc-container', StickyAtcContainer);
